module.exports = __webpack_public_path__ + "img/kcjt-icon.dad3d0e4.png";